import { useEffect } from 'react';
import { AddProductInCartButton } from '../../buttons/addProductInCartButton/AddProductInCartButton';
import { DeleteProductFromCartButton } from '../../buttons/deleteProductFromCartButton/DeleteProductFromCartButton';
import { DeleteProductButton } from '../../buttons/deleteProductButton/DeleteProductButton';
import Preloader from '../../preloader/Preloader';
import styles from './Product.module.css';


export const Product = ({
    products,
    isLoading,
    showModal,
    isAuthorized,
    address,
    addProductInCart,
    deletePurchasedProduct,
    cartList
}) => {

    let newCartList = cartList?.map(function (cart) {
        return cart.id
    })

    return (
        <div className={styles.cardsContainer}>
            
                 
                {(isLoading === false) ? products.map(product => (
                    <div className={styles.card}>
                        <img
                            src={product.url}
                            onClick={() => showModal(product.id)}
                            className={styles.photo}
                        />
                        <div className={styles.description}>
                            <div className={styles.productName}>
                                {product.name}
                            </div>
                            <div className={styles.containerPrice}>
                                <div className={styles.productPrice}>
                                    {product.price} грн
                                </div>
                                <div className={styles.productWeight}>
                                    {product.weight} г
                                </div>
                            </div>
                            <div className={styles.buttonsContainer}>
    
                                {newCartList?.includes(product.id) ?
    
                                    <DeleteProductFromCartButton id={product.id}
                                                                deletePurchasedProduct={deletePurchasedProduct} />
                                    :
                                    <AddProductInCartButton addProductInCart={addProductInCart}
                                                            id={product.id} />
                                }
    
                                {
                                    isAuthorized &&
                                    <div className={styles.deleteButton}>
                                        <DeleteProductButton id={product.id}
                                                            address={address} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                ))
                : 
                <Preloader />
                            }
        </div>
    );
}